import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { Form, Checkbox, Select } from 'components/forms'
import Divider from 'components/Divider'
import { loadAppConstants } from 'gql/query'

const Visible = ({ data = {}, formData = {}, mutations: { updateItem } }) => {
	const [t, i18n] = useTranslation()
	const { bakeryReturn = [] } = formData

	return(
		<Form initialValues={formData} onSubmit={updateItem} smartSubmit>
			<Row>
				<Col xs>
					<Select
						label={t('product_section.strings.visible')}
						field='visibleStatus'
						remoteOptions={{ query: loadAppConstants, variables: { type: 32, language: i18n.language } }}
						{...data?.FA_ProductId && {
							disabled: true,
							title: t('product_section.strings.product_from_FA')
						}}
					/>
				</Col>
				<Col xs className='narrow-col'>
					<Divider height={25}/>
					{bakeryReturn.map((item, i) => <Checkbox label={`${t('product_section.fields.with_drawal')} ${i + 1}`} field={`bakeryReturn[${i}]`} key={i} />)}
				</Col>
				<Col xs className='narrow-col'>
					<Divider height={25}/>
					<Checkbox field='bakeryReturnEndOfDay' label={t('product_section.fields.evening_return')} />
					<Checkbox field='bakeryStock' label={t('product_section.fields.stock')} />
				</Col>
			</Row>
		</Form>
	)
}

export default Visible
